import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { productsByCategory, uniformCategories } from '../data/productsData';
import ProductListing from './ProductListing';

export default function UniformDetail() {
  const { slug } = useParams();
  const products = productsByCategory[slug];
  const catInfo  = uniformCategories.find(c => c.slug === slug);
  if (!products || !catInfo) return <Navigate to="/uniforms" replace />;

  const meta = {
    title:   catInfo.title,
    tagline: catInfo.tagline,
    img:     catInfo.img,
    color:   catInfo.color,
  };

  return <ProductListing catMeta={meta} products={products} backPath="/uniforms" backLabel="Uniforms" />;
}